import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import { INTERNATIONAL_MOMENT_DATE_FORMAT } from "src/components/constants";
import {
    CompanySizes
} from "src/modules/3rd-party-management/constants";
import DateUtils from "src/services/utils/DateUtils";

const GeneralInfos = ({ t, dataIsLoading, basicInfos }) => {
    if (dataIsLoading || !basicInfos?.type) {
        return (
            <Row>
                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <p style={{ width: '40%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                    <p style={{ width: '100%', height: '34px' }} className={`dt-field dt-skeleton`}></p>
                </Col>
            </Row>
        )
    }

    const dateUtils = new DateUtils();

    const renderIndividualBody = () => {
        return (
            <Row>
                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Name')}:
                    </Label>

                    <p>
                        {basicInfos.name}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Nickname / AKA')}:
                    </Label>
                    <p>
                        {basicInfos.shortName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Date of Birth')}:
                    </Label>
                    <p>
                        {basicInfos.individualDateOfBirth ?
                            dateUtils.convertDateToDate(basicInfos.individualDateOfBirth, INTERNATIONAL_MOMENT_DATE_FORMAT) :
                            null}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Country of Birth')}:
                    </Label>
                    <p>
                        {t(basicInfos.individualBirthPlaceCountry?.name)}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Tax ID')}:
                    </Label>
                    <p>
                        {basicInfos.individualTaxId}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('National ID Number')}:
                    </Label>
                    <p>
                        {basicInfos.individualNationalIdNumber}
                    </p>
                </Col>
            </Row>
        )
    }

    const renderCompanyBody = () => {
        return (
            <Row>
                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Company Name')}:
                    </Label>

                    <p>
                        {basicInfos.name}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Short Name')}:
                    </Label>
                    <p>
                        {basicInfos.shortName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Brands')}:
                    </Label>
                    <p>
                        {basicInfos.brands}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Industries')}:
                    </Label>
                    <p>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {
                                (basicInfos.industries || [])
                                    .map((industry) => `${industry.class} - ${industry.name}`)
                                    .join('\n')
                            }
                        </div>
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Employee Size')}:
                    </Label>
                    <p>
                        {CompanySizes[basicInfos.employeeSize] ? (
                            <>
                                {`${CompanySizes[basicInfos.employeeSize]?.title} ${t("Employees")}`}
                            </>
                        ) : null}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="4" className="mb-2">
                    <Label className="form-label">
                        {t('Website')}:
                    </Label>
                    <p>
                        {basicInfos.websiteUrl}
                    </p>
                </Col>
            </Row>
        )
    }

    if (basicInfos.type === 'individual') {
        return renderIndividualBody()
    }

    return renderCompanyBody();
}

export default withNamespaces()(
    GeneralInfos
);